const logosBaseUrl = window.env.LOGOS_BASE_URL;
const themesBaseUrl = window.env.THEMES_BASE_URL;

export const BRAND_LOGO_URL = {
  storebrand: `${logosBaseUrl}/beta/storebrand-logo-desktop.svg`,
  storebrandWhite: `${logosBaseUrl}/beta/storebrand-logo-desktop-negative.svg`,
  storebrandMobile: `${logosBaseUrl}/beta/storebrand-logo-only.svg`,
  coop_rgb: `${logosBaseUrl}/coop-logo-rgb.svg`,
  akademikerne: `${logosBaseUrl}/akademikerne-plus-logo.svg`,
  danskeBank: `${logosBaseUrl}/danske-bank-logo.svg`,
  huseierne: `${logosBaseUrl}/huseierne-logo.svg`,
};

export const PARTNER_THEME_URL = {
  coop: `${themesBaseUrl}/coop.light.css`,
  akademikerne: `${themesBaseUrl}/akademikerne.light.css`,
  danskeBank: `${themesBaseUrl}/danica.light.css`,
  huseierne: `${themesBaseUrl}/huseierne.light.css`,
};

export const PARTNER_FOOTER_IN_COOPERATION_WITH =
  'partner.footer.inCooperationWith';
